import API from '../api';
import $log from 'src/log/log';

interface GetOrCreateInfiniteCanvasConfig {
  teamId: string;
  canvasId: string;
  config: {
    templateId?: string | null;
    name?: string | null;
  };
}

class InfiniteCanvas extends API {
  infiniteCanvasEndpoint = '/infinite-canvas';

  getOrCreateInfiniteCanvas({ teamId, canvasId, config }: GetOrCreateInfiniteCanvasConfig) {
    return super.get(`${this.infiniteCanvasEndpoint}/${teamId}/${canvasId}`, config);
  }

  list(organizationId: string) {
    return super.get(`${this.infiniteCanvasEndpoint}/${organizationId}`);
  }

  delete(organizationId: string, canvasId: string) {
    return super.delete(`${this.infiniteCanvasEndpoint}/${organizationId}/${canvasId}`);
  }

  listTemplates() {
    $log.debug('Fetching templates');
    return super.get(`${this.infiniteCanvasEndpoint}/template`);
  }

  update(organizationId: string, canvasId: string, data: { name: string }) {
    return super.put(`${this.infiniteCanvasEndpoint}/${organizationId}/${canvasId}`, data);
  }
}

const infiniteCanvasApi = new InfiniteCanvas();
export default infiniteCanvasApi;
